import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MaterialModule } from '../material.module';
import { SelectAgentDropDownComponent } from './select-agent-drop-down/select-agent-drop-down.component';
import { SelectBranchDropDownComponent } from './select-branch-drop-down/select-branch-drop-down.component';
import { SelectCashbookDropDownComponent } from './select-cashbook-drop-down/select-cashbook-drop-down.component';
import { SelectCompanyDropDownComponent } from './select-company-drop-down/select-company-drop-down.component';
import { SelectCreditTermsDropDownComponent } from './select-credit-terms-drop-down/select-credit-terms-drop-down.component';
import { SelectCurrencyDropDownComponent } from './select-currency-drop-down/select-currency-drop-down.component';
import { SelectCustomerDropDownComponent } from './select-customer-drop-down/select-customer-drop-down.component';
import { SelectFiItemDropDownComponent } from './select-fi-item-drop-down/select-fi-item-drop-down.component';
import { SelectGlcodeDropDownComponent } from './select-glcode-drop-down/select-glcode-drop-down.component';
import { SelectInvItemDropDownComponent } from './select-inv-item-drop-down/select-inv-item-drop-down.component';
import { SelectLocationDropDownComponent } from './select-location-drop-down/select-location-drop-down.component';
import { SelectPrintableFormatDropDownComponent } from './select-printable-format-drop-down/select-printable-format-drop-down.component';
import { SelectSettlementMethodDropDownComponent } from './select-settlement-method-drop-down/select-settlement-method-drop-down.component';
import { SelectSSTDropDownComponent } from './select-sst-drop-down/select-sst-drop-down.component';
import { SelectSupplierDropDownComponent } from './select-supplier-drop-down/select-supplier-drop-down.component';
import { SelectWHTDropDownComponent } from './select-wht-drop-down/select-wht-drop-down.component';
import { SelectBranchDropDownV2Component } from './select-branch-drop-down-v2/select-branch-drop-down-v2.component';
import { SelectLocationDropDownV2Component } from './select-location-drop-down-v2/select-location-drop-down-v2.component';
import { SelectLocationDropDownStockComponent } from './select-location-drop-down-stock/select-location-drop-down-stock.component';
import { SelectLocationDropDownStockToComponent } from './select-location-drop-down-stock-to/select-location-drop-down-stock-to.component';
import {SelectCompanyDropDownV2Component} from './select-company-drop-down-v2/select-company-drop-down-v2.component';

@NgModule({
  declarations: [
    SelectBranchDropDownComponent,
    SelectLocationDropDownComponent,
    SelectInvItemDropDownComponent,
    SelectFiItemDropDownComponent,
    SelectCustomerDropDownComponent,
    SelectSupplierDropDownComponent,
    SelectCompanyDropDownComponent,
    SelectCashbookDropDownComponent,
    SelectGlcodeDropDownComponent,
    SelectCurrencyDropDownComponent,
    SelectCreditTermsDropDownComponent,
    SelectSettlementMethodDropDownComponent,
    SelectAgentDropDownComponent,
    SelectSSTDropDownComponent,
    SelectWHTDropDownComponent,
    SelectPrintableFormatDropDownComponent,
    SelectBranchDropDownV2Component,
    SelectLocationDropDownV2Component,
    SelectCompanyDropDownV2Component,
    SelectLocationDropDownStockComponent,
    SelectLocationDropDownStockToComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    SelectBranchDropDownComponent,
    SelectLocationDropDownComponent,
    SelectInvItemDropDownComponent,
    SelectFiItemDropDownComponent,
    SelectCustomerDropDownComponent,
    SelectSupplierDropDownComponent,
    SelectCompanyDropDownComponent,
    SelectCashbookDropDownComponent,
    SelectGlcodeDropDownComponent,
    SelectCurrencyDropDownComponent,
    SelectCreditTermsDropDownComponent,
    SelectSettlementMethodDropDownComponent,
    SelectAgentDropDownComponent,
    SelectSSTDropDownComponent,
    SelectWHTDropDownComponent,
    SelectPrintableFormatDropDownComponent,
    SelectBranchDropDownV2Component,
    SelectLocationDropDownV2Component,
    SelectCompanyDropDownV2Component,
    SelectLocationDropDownStockComponent,
    SelectLocationDropDownStockToComponent
  ]
})
export class DropDownModule { }
